export default "__VITE_ASSET__C8bAK83v__"